import React from 'react';
// import { MDBCarousel, MDBCarouselItem } from 'mdb-react-ui-kit';
import Carousel from "react-bootstrap/Carousel";
import bg01 from '../assets/img/hero-bg.jpg';

export default function Header () {
    return (
      // <section id="hero" className="d-flex align-items-center">
      //   <div className="container position-relative" data-aos="fade-up" data-aos-delay="500">
      //     <h1>주식회사 공간지적측량</h1>
      //     <h2>고객의 든든한 파트너, 기술인이 되어 드리겠습니다.</h2>
      //     {/* <a href="#about" className="btn-get-started scrollto">Get Started</a> */}
      //   </div>
      // </section>
      <Carousel data-bs-theme="light">
        <Carousel.Item>
          <section id="hero" className="d-flex align-items-center">
            <div className="container position-relative" data-aos="fade-up" data-aos-delay="500">
              <h1>주식회사 공간지적측량</h1>
              <h2>고객의 든든한 파트너, 기술인이 되어 드리겠습니다.</h2>
            </div>
          </section>
        </Carousel.Item>
        <Carousel.Item>
        <section id="hero2" className="d-flex align-items-center">
            <div className="container position-relative" data-aos="fade-up" data-aos-delay="500">
              <h1>주식회사 공간지적측량</h1>
              <h2>고객의 든든한 파트너, 기술인이 되어 드리겠습니다.</h2>
            </div>
          </section>
        </Carousel.Item>
        <Carousel.Item>
        <section id="hero3" className="d-flex align-items-center">
            <div className="container position-relative" data-aos="fade-up" data-aos-delay="500">
              <h1>주식회사 공간지적측량</h1>
              <h2>고객의 든든한 파트너, 기술인이 되어 드리겠습니다.</h2>
            </div>
          </section>
        </Carousel.Item>
      </Carousel>
    );
}